import { render } from "./MassServiceNotifications.vue?vue&type=template&id=6c387d93"
import script from "./MassServiceNotifications.vue?vue&type=script&lang=js"
export * from "./MassServiceNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__